import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General", message: "" });
  const [busy, setBusy] = useState(false);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Thank you — our atelier will be in touch.");
      setForm({ name: "", email: "", phone: "", subject: "General", message: "" });
    } catch (e2) {
      toast.error(formatApiError(e2.response?.data?.detail) || "Failed to send");
    } finally { setBusy(false); }
  };

  return (
    <div className="ja-container py-16 md:py-24" data-testid="contact-page">
      <div className="text-center mb-16">
        <p className="ja-overline">Get In Touch</p>
        <h1 className="ja-serif text-5xl md:text-6xl mt-3 tracking-tight">Speak With The Atelier</h1>
        <p className="mt-4 max-w-xl mx-auto text-sm" style={{ color: "var(--ja-muted)" }}>
          For private appointments, bespoke enquiries, or after-sales care — our concierge is at your service.
        </p>
      </div>
      <div className="grid md:grid-cols-12 gap-12">
        <aside className="md:col-span-4 space-y-8">
          {[
            [Mail, "Email", "jewelsashu5@gmail.com"],
      
            [MapPin, "Atelier", "jaipur, Rajastathan-302003(India)"],
          ].map(([Icon, label, val]) => (
            <div key={label} className="flex gap-4">
              <Icon size={18} style={{ color: "var(--ja-gold)" }} />
              <div>
                <p className="ja-overline">{label}</p>
                <p className="text-sm mt-2">{val}</p>
              </div>
            </div>
          ))}
        </aside>
        <form onSubmit={submit} className="md:col-span-8 grid sm:grid-cols-2 gap-6">
          <input required placeholder="Full Name" className="ja-input" value={form.name} onChange={onChange("name")} data-testid="contact-name" />
          <input required type="email" placeholder="Email Address" className="ja-input" value={form.email} onChange={onChange("email")} data-testid="contact-email" />
          <input placeholder="Phone" className="ja-input" value={form.phone} onChange={onChange("phone")} data-testid="contact-phone" />
          <select className="ja-input" value={form.subject} onChange={onChange("subject")} data-testid="contact-subject">
            <option>General</option><option>Bespoke</option><option>After-Sales</option><option>Press</option>
          </select>
          <textarea required rows={6} placeholder="How can we help?" className="ja-input sm:col-span-2 resize-none" value={form.message} onChange={onChange("message")} data-testid="contact-message" />
          <div className="sm:col-span-2">
            <button type="submit" disabled={busy} className="ja-btn" data-testid="contact-submit">{busy ? "Sending…" : "Send Enquiry"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
